/* eslint-disable @nfq/sort-keys */
/* eslint-disable @nfq/no-empty-lines-in-objects */
import {generateThemes} from '@nfq/colors';

import type {GetThemeType} from '@nfq/colors';

export const BaseColors = {
    /* ── Primary — Forest Green ─────────────────────────── */
    /** Primary Default. Brand color, main CTAs, active states. ![#154212](https://via.placeholder.com/12/154212/154212.png) `#154212`. */
    primaryDefault: '#154212',
    /** Primary Light. Hover/pressed shift, gradients. ![#2D5A27](https://via.placeholder.com/12/2D5A27/2D5A27.png) `#2D5A27`. */
    primaryLight: '#2D5A27',
    /** Primary Pale. Badges, active chip bg, avatar bg. ![#BCF0AE](https://via.placeholder.com/12/BCF0AE/BCF0AE.png) `#BCF0AE`. */
    primaryPale: '#BCF0AE',

    /* ── Accent — Warm Amber ────────────────────────────── */
    /** Accent Default. Metadata accent, rating text. ![#944A00](https://via.placeholder.com/12/944A00/944A00.png) `#944A00`. */
    accentDefault: '#944A00',
    /** Accent Warm. Download button, highlights. ![#FC8F34](https://via.placeholder.com/12/FC8F34/FC8F34.png) `#FC8F34`. */
    accentWarm: '#FC8F34',
    /** Accent Pale. Rating badge bg, star fill. ![#FFB783](https://via.placeholder.com/12/FFB783/FFB783.png) `#FFB783`. */
    accentPale: '#FFB783',

    /* ── Surface — Warm Neutrals ────────────────────────── */
    /** Surface Background. Page background. ![#F5FCEF](https://via.placeholder.com/12/F5FCEF/F5FCEF.png) `#F5FCEF`. */
    surfaceBackground: '#F5FCEF',
    /** Surface Low. Card backgrounds. ![#EFF6E9](https://via.placeholder.com/12/EFF6E9/EFF6E9.png) `#EFF6E9`. */
    surfaceLow: '#EFF6E9',
    /** Surface Mid. Section backgrounds. ![#E9F0E4](https://via.placeholder.com/12/E9F0E4/E9F0E4.png) `#E9F0E4`. */
    surfaceMid: '#E9F0E4',
    /** Surface High. Input backgrounds, inactive chips. ![#E3EADE](https://via.placeholder.com/12/E3EADE/E3EADE.png) `#E3EADE`. */
    surfaceHigh: '#E3EADE',
    /** Surface Dim. Placeholder images, progress track. ![#D5DCD0](https://via.placeholder.com/12/D5DCD0/D5DCD0.png) `#D5DCD0`. */
    surfaceDim: '#D5DCD0',
    /** White. Cards, overlays. ![#FFFFFF](https://via.placeholder.com/12/FFFFFF/FFFFFF.png) `#FFFFFF`. */
    white: '#FFFFFF',

    /* ── Ink — Text Colors ──────────────────────────────── */
    /** Ink Primary. Headlines, body text. Never use #000. ![#171D16](https://via.placeholder.com/12/171D16/171D16.png) `#171D16`. */
    inkPrimary: '#171D16',
    /** Ink Secondary. Secondary text, descriptions. ![#42493E](https://via.placeholder.com/12/42493E/42493E.png) `#42493E`. */
    inkSecondary: '#42493E',
    /** Ink Tertiary. Captions, metadata. ![#535353](https://via.placeholder.com/12/535353/535353.png) `#535353`. */
    inkTertiary: '#535353',
    /** Ink Disabled. Placeholder text, disabled states. ![#C2C9BB](https://via.placeholder.com/12/C2C9BB/C2C9BB.png) `#C2C9BB`. */
    inkDisabled: '#C2C9BB',

    /* ── Semantic ───────────────────────────────────────── */
    /** Error. Error states. ![#BA1A1A](https://via.placeholder.com/12/BA1A1A/BA1A1A.png) `#BA1A1A`. */
    error: '#BA1A1A',
    /** Error Surface. Error background. ![#FFDAD6](https://via.placeholder.com/12/FFDAD6/FFDAD6.png) `#FFDAD6`. */
    errorSurface: '#FFDAD6'
} as const;

export const DerivedColors = {primaryTransparent: `${BaseColors.primaryDefault}f1`} as const;

export const BoxShadows = {
    /** Elevation/Card — Karten auf Surface/Low. */
    cardShadow: '0px 4px 16px rgba(23, 29, 22, 0.08)',
    /** Elevation/Floating — FAB, Audio Player. */
    floatingShadow: '0px 8px 24px rgba(23, 29, 22, 0.06)'
} as const;

export type BaseColorsType = GetThemeType<typeof BaseColors>;
export const {
    globalCss,
    shadows,
    themeColors,
    themes
} = generateThemes({
    baseColors: BaseColors,
    derivedColors: DerivedColors,
    shadows: BoxShadows
});